//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import _ from "js/underscore-mixins";

// This directive is used in a datatable where multiple data are included in a single column.
// In this case a single column can be sorted on either data, depending on which the user selects.
//
// Note: this directive makes the following assumptions in the corresponding HTML:
//  1. The 'name' and 'sortKey' attributes passed to datatable must each be formatted as an array.
//  2. The ordering of each title and sortable must parallel each other. So the following
//          name="['Username', 'Followers']" and sortKey="['username', 'follower_count']"
//     will imply the correspondences 'Username' --> 'username' and 'Followers' --> 'follower_count'
//
// This directive is attached by including 'datatable-multi-col-header=true' in the datatable-table-column directive.
// ex. <datatable-table-column name="['Username', 'Followers']"
//                             sortKey="['username', 'follower_count']"
//                             sortable="true"
//                             datatable-multi-col-header="true">

(function() {
  angular.module('curalate').directive('datatableMultiColumnHeader', ['StringUtils', function(StringUtils) {
    return {
      restrict: 'E',
      template: '<span ng-repeat="sort in model.sorts" ' +
                            'ng-click="model.setSort(sort)" ' +
                            'ng-class="{ selected : sort.isSelected }">' +
                            '{{ sort.name }}' +
                      '</span>',
      scope: {
        name: '&',
        sortKey: '&',
      },
      link(scope) {
        let getIndexFromSortKey;
        const sortKey = scope.sortKey();

        scope.model = {
          sorts: [],
        };

                // Splits the input 'name' and 'sortKey' strings into paired off sorts.
                // Note: ideally, `$parent` wouldn't be used and instead, datatable's controller would be required with
                // methods to access datatable's scope but `require: '^datatable'` causes the controller to not be found
                // so accessing `$parent` will work for now.
        function extractSorts() {
          let lastMultiColSortIndex;
          let currentTableSort = false;

          scope.model.sorts = _.map(scope.name(), name => ({ name }));
          _.each(sortKey, (sort, i) => {
            scope.model.sorts[i].sortKey = sort;
            scope.model.sorts[i].isSelected = sort === scope.$parent.model.sorting.currentSortKey;
            if (scope.model.sorts[i].isSelected) {
              currentTableSort = true;
              scope.$parent.model.multiCols[sortKey] = scope.model.sorts[i].sortKey;
            }
          });

                    // One of the sorts must be selected as the current sortKey of the column.
          if (!currentTableSort) {
            if (sortKey in scope.$parent.model.multiCols) {
              lastMultiColSortIndex = getIndexFromSortKey(scope.$parent.model.multiCols[sortKey]);
              scope.model.sorts[lastMultiColSortIndex].isSelected = true;
            } else {
              scope.model.sorts[0].isSelected = true;

              scope.$parent.model.multiCols[sortKey] = scope.model.sorts[0].sortKey;
            }
          }
        }

                // Given a sortKey, returns the index of the corresponding sort object in $scope.model.sorts.
        getIndexFromSortKey = function(key) {
          return scope.model.sorts.indexOf(_.find(scope.model.sorts, sort => sort.sortKey === key));
        };

                // When the user selects data to sort on in the multi col, sort on that data.
        scope.model.setSort = function(sort) {
          const sortIndex = scope.model.sorts.indexOf(sort);
          const tableName = scope.$parent.name;
          const eventName = StringUtils.formatString('datatable:%s:new-sort', tableName);
          scope.$parent.model.multiCols[sortKey] = scope.model.sorts[sortIndex].sortKey;

          _(scope.model.sorts).each((e, i) => {
            e.isSelected = i === sortIndex;
          });

          scope.$emit(eventName, sort.sortKey, true);
        };

        extractSorts();
      },
    };
  }]);
})();
